export default __webpack_public_path__ + "static/media/Snd_TryU.b50c5d8a.mp3";